import { useCallback, useEffect } from 'react';

import { FormattedMessage } from 'react-intl';
import { Prompt } from 'react-router';
import { Alert, Button } from 'reactstrap';
import { UNSAVED_CHANGES_PROMPT } from '../../consts/consts';
import { useEventSerializer } from '../../utils/util/EventSerializer';

const ObjectiveAutosavePrompt = ({}) => {
  const [, hasPendingChanges, failedSaves, retryFailedSaves] =
    useEventSerializer();
  const leavePromptMessage = UNSAVED_CHANGES_PROMPT;
  const onUnload = useCallback(
    (e) => {
      if (hasPendingChanges) {
        e.preventDefault();
        e.returnValue = leavePromptMessage;
        return leavePromptMessage;
      }
    },
    [hasPendingChanges, leavePromptMessage]
  );
  useEffect(() => {
    window.addEventListener('beforeunload', onUnload);
    return () => window.removeEventListener('beforeunload', onUnload);
  }, [hasPendingChanges, onUnload]);
  // Several objectives often fail for the same reason: list each reason once.
  const failureMessages = [
    ...new Set(failedSaves.map(({ message }) => String(message))),
  ];
  return (
    <>
      <Prompt when={hasPendingChanges} message={UNSAVED_CHANGES_PROMPT} />
      {hasPendingChanges && (
        <span data-testid="background-saving" hidden={true}>
          {'Saving...'}
        </span>
      )}
      {failureMessages.length > 0 && (
        <Alert
          color="danger"
          className="d-flex align-items-start justify-content-between gap-3"
          data-testid="objective-save-failed"
        >
          <div>
            <FormattedMessage
              id="app.views.objectives.objective_autosave_prompt.save_failed"
              defaultMessage="Some of your changes couldn't be saved:"
            />
            <ul className="mb-0">
              {failureMessages.map((message) => (
                <li key={message}>{message}</li>
              ))}
            </ul>
          </div>
          <Button
            color="white"
            size="sm"
            className="flex-shrink-0 align-self-center"
            onClick={retryFailedSaves}
          >
            <FormattedMessage
              id="app.views.objectives.objective_autosave_prompt.retry"
              defaultMessage="Retry"
            />
          </Button>
        </Alert>
      )}
    </>
  );
};

export default ObjectiveAutosavePrompt;
